module.exports = __webpack_public_path__ + "img/img25.e0e223ad.jpg";